import { authRequest } from "src/engine/modules/authRequest"
import queryString from "query-string"
import { showToast } from "@infotech/uikit-toasts"

export const getDefaultFilter = ({ planUuid, history, basicUrl }) => {
  authRequest({ url: `/plans/${planUuid}/calendar-view` })
    .then(({ data }) => {
      const haveFilter = Boolean(data.filter)
      history.push(
        `${basicUrl}${haveFilter ? `?${queryString.stringify(data)}` : ``}`,
      )
    })
    .catch(error => {
      showToast({
        type: `error`,
        message: `${error.message}`,
        hideIn: 5,
      })
    })
}
